<template>
  <v-layout v-if="translation" row justify-center>
    <v-dialog v-model="editorOpen" persistent max-width="600px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="translation.name"
                  single-line
                  :placeholder="$t('labelTitle')"
                  :rules="[rules.required, rules.maxLength]"
                  counter="255"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="[
                    {
                      text: $t('itemFrench'),
                      value: 'fr_FR',
                    },
                    {
                      text: $t('itemEnglish'),
                      value: 'en_GB',
                    },
                    {
                      text: $t('itemGerman'),
                      value: 'de_DE',
                    },
                    {
                      text: $t('itemNL'),
                      value: 'nl_NL',
                    },
                    {
                      text: $t('itemItalian'),
                      value: 'it_IT',
                    },
                    {
                      text: $t('itemSpanish'),
                      value: 'es_ES',
                    },
                    {
                      text: $t('itemPortuguese'),
                      value: 'pt_PT',
                    }]"
                  menu-props="auto"
                  label="Langue*"
                  v-model="translation.locale"
                  hide-details
                  single-line
                />
              </v-flex>
              <v-flex xs12 v-if="includeDescription === true">
                <vue-editor
                  v-model="translation.description"
                  :placeholder="$t('descriptionPlaceHolder')"
                  :editorToolbar="customToolbar"
                  id="description-editor"
                />
              </v-flex>
            </v-layout>
          </v-container>
          <small>{{ $t('labelMandatoryFields') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="$emit('closeclicked')">{{ $t('btnCancel')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="!translationIsValid"
            text
            @click="save">{{ $t('btnSave')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { v4 as uuidv4 } from 'uuid';

import validator from '../../services/validation';

export default {
  components: { VueEditor },
  props: {
    initialTranslation: {
      type: Object,
      required: false,
      default: () => null,
    },
    includeDescription: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      customToolbar: [
        [
          'bold',
          'italic',
          'underline',
          { list: 'ordered' },
          { list: 'bullet' },
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { header: [1, 2, 3, false] },
        ],
      ],
      editorOpen: true,
      translation: null,
      rules: {
        required: (value) => !!value || this.$t('ruleRequired'),
        maxLength: (value) => validator.ValidateMaxLength(value, 255) || this.$t('ruleTooLong'),
      },
    };
  },
  computed: {
    translationIsValid() {
      if (
        this.rules.required(this.translation.name) === true
        && this.rules.maxLength(this.translation.name, 255) === true
      ) {
        return true;
      }
      return false;
    },
    title() {
      if (this.initialTranslation) {
        return this.$t('titleUpdate');
      }
      return this.$t('titleCreate');
    },
  },
  methods: {
    save() {
      if (!this.translationIsValid) {
        return;
      }
      this.$emit('savetranslation', this.translation);
    },
  },
  mounted() {
    if (this.initialTranslation) {
      this.translation = {
        id: this.initialTranslation.id,
        name: this.initialTranslation.name,
        description: this.initialTranslation.description,
        locale: this.initialTranslation.locale,
      };
    } else {
      this.translation = {
        id: uuidv4(),
        name: '',
        description: '',
        locale: 'fr_FR',
      };
    }
  },
};
</script>
<i18n>
{
  "fr": {
    "labelMandatoryFields": "*Champs obligatoires",
    "btnCancel": "Annuler",
    "btnSave": "Enregistrer",
    "titleCreate": "Créer une traduction",
    "titleUpdate": "Modifier une traduction",
    "ruleRequired": "Ce champ ne peut pas être vide",
    "ruleTooLong": "Nom trop long",
    "descriptionPlaceHolder": "Description",
    "labelLanguage": "Langue*",
    "labelTitle": "Titre*",
    "itemFrench": "Français",
    "itemEnglish": "Anglais",
    "itemGerman": "Allemand",
    "itemNL": "Néerlandais",
    "itemItalian": "Italien",
    "itemSpanish": "Espagnol",
    "itemPortuguese": "Portugais"
  },
  "en": {
    "labelMandatoryFields": "*Mandatory fields",
    "btnCancel": "Cancel",
    "btnSave": "Save",
    "titleCreate": "Create a translation",
    "titleUpdate": "Update a translation",
    "ruleRequired": "This field cannot be empty",
    "ruleTooLong": "Too long",
    "descriptionPlaceHolder": "Description*",
    "labelLanguage": "Language*",
    "labelTitle": "Title*",
    "itemFrench": "French",
    "itemEnglish": "English",
    "itemGerman": "German",
    "itemNL": "Dutch",
    "itemItalian": "Italian",
    "itemSpanish": "Spanish",
    "itemPortuguese": "Portuguese"
  }
}
</i18n>
